import React, { useMemo } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import Subtitle from '../Subtitle';

const Subtitles = ({ subtitles }) => {
    const { locale } = getContext();

    return useMemo(() => {
        const withActiveLocale = (subtitle) => {
            const { srcLang } = subtitle;

            return {
                ...subtitle,
                active: locale === srcLang
            };
        };

        const toSubtitleJSX = (subtitle) => {
            const {
                src,
                label,
                srcLang,
                active
            } = subtitle;

            return (
                <Subtitle key={src}
                    src={src}
                    label={label}
                    srcLang={srcLang}
                    active={active}/>
            );
        };

        return subtitles
            .map(withActiveLocale)
            .map(toSubtitleJSX);
    }, [subtitles, locale]);
};

Subtitles.propTypes = {
    subtitles: arrayOf(
        shape({
            src: string,
            srcLang: string,
            label: string
        })
    )
};

export default Subtitles;
